import PropTypes from 'prop-types';
import Icon from '../icon';

export default function ResultCounter({ current, total, searchInProgress }) {
  if (searchInProgress) {
    return (<span className="u-clr-orange results-spinner"><Icon.Spinner /></span>);
  }

  if (!total) {
    return <span className="u-clr-orange results-label">No results</span>;
  }

  return (
    <div className="u-display-inline-block result-counter">
      <span className="current">{current}</span>
      <span className="u-margin-xs-hor">/</span>
      <span className="total">{total}</span>
    </div>
  );
}

ResultCounter.propTypes = {
  current: PropTypes.number,
  total: PropTypes.number,
  searchInProgress: PropTypes.bool,
};

ResultCounter.defaultProps = {
  total: 0,
  current: 0,
  searchInProgress: false,
};
